import { useRef } from 'react';
import Cookies from 'js-cookie';
import { checkIsButtonUrl } from 'core/utils/helpers/url';
import { useIsButtonInstalled } from 'core/hooks/useIsButtonInstalled';
import { useIsButtonEligibleForBrowser } from 'core/hooks/useIsButtonEligibleForBrowser';
import { BONUS_BUTTON_MODAL_WAS_SHOWN } from 'core/modules/BonusButton/utils/keys';
import { useModalDetection } from 'core/modules/BonusButton/hooks/useModalDetection';
import config from 'core/modules/BonusButton/configs';

export const useCheckIsEligibleToFetchData = () => {
  const { isPageEligibleToShowModalOrPopup } = config;
  const isButtonPage = checkIsButtonUrl();
  const isPageEligibleToShow = isPageEligibleToShowModalOrPopup && !isButtonPage;
  const bonusButtonModalWasShownRef = useRef(Cookies.get(BONUS_BUTTON_MODAL_WAS_SHOWN));
  const isButtonInstalled = useIsButtonInstalled();
  const hasOpenModal = useModalDetection();
  const isButtonEligibleForBrowser = useIsButtonEligibleForBrowser();
  const bonusButtonModalWasShown = bonusButtonModalWasShownRef.current;

  return (
    isButtonEligibleForBrowser &&
    isPageEligibleToShow &&
    isButtonInstalled === false &&
    !bonusButtonModalWasShown &&
    hasOpenModal === false
  );
};
